const AboutFaroView = Barba.BaseView.extend({
    namespace: 'about-faro',

    onEnter: function() {
        new MainMenu(this.container);
        new InViewAnimation();
        new SearchModal(this.container);

        this.initClientList();
        setIframeAspectRatios(this.container);

        setTimeout(_ => { setScrollAnchorPosition(this.container); }, 500)
        window.addEventListener('hashchange', _ => { setScrollAnchorPosition(this.container); });
    },

    initClientList() {
        const list = this.container.querySelector('.jsClientList');
        const title = list.querySelector('.jsClientListTitle');
        const expandWrapper = list.querySelector('.jsClientListExpandWrapper');
        const loadMoreBtn = list.querySelector('.jsClientListShowMore');

        title.addEventListener('click', _ => {
            if (!expandWrapper.classList.contains('open')) {
                title.classList.add('active');

                TweenLite.set(expandWrapper, { display: 'block', opacity: 0 });
                const height = expandWrapper.offsetHeight;
                TweenLite.set(expandWrapper, { height: 0, opacity: 1 });
                TweenLite.to(expandWrapper, 0.5, { height: height, ease: Power2.easeInOut, onComplete: _ => {
                    expandWrapper.classList.add('open');
                    TweenLite.set(expandWrapper, { clearProps: 'all' });
                } });
            }
            else {
                title.classList.remove('active');

                TweenLite.to(expandWrapper, 0.5, { height: 0, ease: Power2.easeInOut, onComplete: _ => {
                    expandWrapper.classList.remove('open');
                    expandWrapper.classList.remove('open-children');
                    loadMoreBtn.classList.remove('active');

                    TweenLite.set(expandWrapper, { clearProps: 'all' });
                } });
            }            
        });

        loadMoreBtn.addEventListener('click', e => {
            e.preventDefault();

            if (!expandWrapper.classList.contains('open-children')) {    
                const initialHeight = expandWrapper.offsetHeight;
                expandWrapper.classList.add('open-children');

                const height = expandWrapper.offsetHeight;
                TweenLite.set(expandWrapper, { height: initialHeight });
                
                TweenLite.to(expandWrapper, 0.5, { height: height, ease: Power2.easeInOut, onComplete: _ => {
                    loadMoreBtn.classList.add('active');
                    TweenLite.set(expandWrapper, { clearProps: 'all' });
                } });
            }
            else {
                expandWrapper.classList.remove('open-children');
                const height = expandWrapper.offsetHeight;
                expandWrapper.classList.add('open-children');

                TweenLite.to(expandWrapper, 0.5, { height: height, ease: Power2.easeInOut, onComplete: _ => {
                    expandWrapper.classList.remove('open-children');
                    loadMoreBtn.classList.remove('active');
                    TweenLite.set(expandWrapper, { clearProps: 'all' });
                } });
            }
        });
    }
});

AboutFaroView.init();